module.exports = __webpack_public_path__ + "img/charging-hub-suggestion-proprietary.253de2f1.png";